// utils.js
export const formatDate = (date, includeTime = false) => {
  if (!date || isNaN(new Date(date))) {
    return "N/A";
  }
  const dateOptions = {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
  };
  const timeOptions = {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  };
  const formattedDate = new Date(date).toLocaleDateString("en-US", dateOptions);
  if (includeTime) {
    const formattedTime = new Date(date).toLocaleTimeString("en-US", timeOptions);
    return `${formattedDate} - ${formattedTime}`;
  }
  return formattedDate;
};

export const truncateText = (text, maxLength = 30) => {
  if (typeof text !== "string" || text.length <= maxLength) {
    return text;
  }
  return `${text.substring(0, maxLength)}...`;
};